import appConfig from "../../../config/app";

export const paths = {
  basename: "/",
  Consumos: "/Consumos",
  Login: "/Login",
  SeleccionarSolucion: "/SeleccionarSolucion",
  RecuperarPassword: appConfig.APP_URL + "/RecuperarPasswordRevolution.aspx",
};